// Stub: react-native-animated-glow — glow effect not available on web/desktop
// AIGlowBorder renders the children without the glow effect.
import React from 'react';
import { View } from 'react-native';

const AnimatedGlow = ({ children, style }) =>
  React.createElement(View, { style }, children);

export default AnimatedGlow;
